import axiosInstance from '@/utils/api.js'

function validation (payload) {
  // if (payload.validation_flags === 4 && payload.value_type === 1) {
  //   payload.raw_values[0].value = parseInt(payload.raw_values[0].value, 10)
  // }
}

var state = {
  registrySettingGroups: [],
  registrySettings: [],
  registrySettingsSysCurrency: [],
  registrySettingsPhoneFormat: '1(111)111-11-11'
}

var getters = {
  REGISTRY_SETTING_GROUPS: (state) => {
    return state.registrySettingGroups
  },
  REGISTRY_SETTINGS: (state) => {
    return state.registrySettings
  },
  REGISTRY_SETTINGS_SYS_CURRENCY: (state) => {
    return parseInt(state.registrySettingsSysCurrency)
  },
  REGISTRY_SETTINGS_PHONE_FORMAT: (state) => {
    return state.registrySettingsPhoneFormat
  }
}

var mutations = {
  SET_REGISTRY_SETTING_GROUPS: (state, payload) => {
    state.registrySettingGroups = payload
  },
  SET_REGISTRY_SETTINGS: (state, payload) => {
    state.registrySettings = payload
  },
  SET_REGISTRY_SETTINGS_SYS_CURRENCY: (state, payload) => {
    let elCurrency
    payload.forEach(element => {
      if (element.name === 'system_currency') {
        elCurrency = element.raw_values[0].value
      }
    })
    state.registrySettingsSysCurrency = elCurrency
  },
  SET_REGISTRY_SETTINGS_PHONE_FORMAT: (state, payload) => {
    let elData
    payload.forEach(element => {
      if (element.name === 'customer_portal_phone_format') {
        elData = element.raw_values[0].value
      }
    })
    state.registrySettingsPhoneFormat = elData
  }
}

var actions = {
  GET_REGISTRY_SETTING_GROUPS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/registry_settings_group?comp_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_REGISTRY_SETTING_GROUPS', result.data)
    }
  },
  GET_REGISTRY_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/registry_settings_form?group_id=' + payload.group_id + '&object_id=' + payload.object_id)
    if (result.status === 200) {
      context.commit('SET_REGISTRY_SETTINGS', result.data)
    }
  },
  GET_REGISTRY_SYSTEM_VAT: async (context, payload) => {
    let result = await axiosInstance.get('/settings/system_vat_tax')
    if (result.status === 200) {
      return result.data
    }
    return null
  },
  GET_REGISTRY_SETTINGS_SYSTEM_CURRENCY: async (context) => {
    let result = await axiosInstance.get('/settings/registry_settings_form?group_id=2&object_id=0')
    if (result.status === 200) {
      context.commit('SET_REGISTRY_SETTINGS_SYS_CURRENCY', result.data)
    }
  },
  UPDATE_REGISTRY_SETTING: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/registry_setting', payload)
  },
  GET_REGISTRY_SETTINGS_PHONE_FORMAT: async (context) => {
    let result = await axiosInstance.get('/settings/registry_settings_form?group_id=15&object_id=0')
    if (result.status === 200) {
      context.commit('SET_REGISTRY_SETTINGS_PHONE_FORMAT', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/registrySettings.js